import { AnalyticsReportProductV2 } from "@/utils/analyticsEventSender";

export default async function sendBeginCheckoutEvent(beginCheckoutRequest: BeginCheckoutRequest) {
  try {
    const response = await fetch("/rest/neo/gtm/sendBeginCheckoutEvent", {
      credentials: "include",
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(beginCheckoutRequest), // body data type must match "Content-Type" header
    });

    if (!response.ok) {
      console.error("Failed to send begin checkout event", response.statusText);
    } else {
      console.log("Begin checkout event sent successfully");
    }
  } catch (error) {
    console.error("Error sending begin checkout event", error);
  }
}

export type BeginCheckoutRequest = {
  event_id: string;
  user_id: number;
  currency: string;
  value: number;
  items: AnalyticsReportProductV2[];
};
